<template>
    <div :class="stepWrapperClasses" :key="step">
        <div class="step-body">
            <div v-if="locationsLoaded">
                <h5 class="step-field-heading"><span class="las back" v-if="isNotFirstStep" @click="prevStep()"><img src="../../assets/arrow_back-24px.svg" ></span>
                <span class="step-field-heading-text">Select Location</span></h5>
                <div class="step-fields-body step-fields-list-box">
                    <div v-for="item in stepData.location" :key="item.id" class="step-field location-wrapper">
                        <location-row
                        :value="value"
                        :item="item"
                        v-on:filled-out="addLocationBookingDetails($event)"></location-row>
                    </div>
                </div>
            </div>
            <div v-else class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
</template>

<script>
  import { mapMutations, mapState, mapGetters } from 'vuex';
  import axios from 'axios';
  import LocationRow from './LocationRow';
  import schedulingMixin from '../../mixins/schedulingMixin';

  export default {
    mixins: [schedulingMixin],
    props: {
      field: {},
      details: {},
      value: '',
      index: '',
    },
    methods: {
        ...mapMutations('scheduling', [
          'addBookingDetails',
          'nextStep',
          'prevStep',
          'setStepData' // referenced in the mixin
        ]),
        async loadLocations() {
            var response;
            response = await axios.get(`${this.domain}/forms/api/v1/forms/${this.formId}/integrations/scheduling/api/locations`);
            this.setCurrentStepData(response.data);
            if (!this.showLocationsStep) {
                this.addLocationBookingDetails(this.form.location);
            }
        },
        addLocationBookingDetails(value) {
            let location = this.getLocationById(value);
            let oldLocation = this.bookingDetails.location;
            this.addBookingDetails({
                'type' : 'location',
                'details' : location
            });
            this.nextStep();
            if (!oldLocation || oldLocation.id != location.id) {
                this.resetStepData();
            }
            this.$emit('filled-out',location);
        },
        getLocationById(id) {
            let locations = this.stepData.location.filter(location => location.id == id);
            if (locations[0]) {
                return locations[0];
            } else {
                return {};
            }
        }
    },
    created() {
        if (!this.showLocationsStep && this.form.location===0) {
            this.setCurrentStepData([{
                id : 0,
                name : ""
            }]);
            this.addLocationBookingDetails(this.form.location);
        } else if (!this.locationsLoaded) {
            this.loadLocations();
        }
    },
    computed: {
        ...mapGetters('form', [
          'fields',
          'domain'
        ]),
        ...mapState('form', { form: 'form', formId: 'formId' }),
        ...mapState('scheduling', { step: 'step', stepData: 'stepData', bookingDetails: 'bookingDetails' }),
        locationsLoaded() {
            return this.stepData.location !== '' && this.showLocationsStep;
        },
        showLocationsStep() {
            return !this.form.hasOwnProperty('location') || this.form.location === '' || this.form.location === null;
        }
    },
    components: {
        LocationRow,
    },
  };
</script>
